export const OPTION_ALL_VALUE = ""
export const OPTION_ALL_LABEL = "Tất cả"
export const GUIDE_EMPTY = "00000000-0000-0000-0000-000000000000"

export const FAILBACK =
  "data:image/png;base64,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"

export const STATUS_POST = [
  "",
  "#ff7875",
  "#40a9ff",
  "#52c41a",
  "#094ad9",
  "#ff9f40",
]

export const COLOR_STATUS = {
  active: "#0d99ff",
  inactive: "#ff4d4f",
}
export const SYSTEM_KEY = {
  DON_VI_TINH: "DON_VI_TINH",
  DON_VI_HANH_CHINH: "DON_VI_HANH_CHINH",
  LOAI_TAI_LIEU: "LOAI_TAI_LIEU",
  THOI_HAN_BAO_QUAN: "THOI_HAN_BAO_QUAN",
  HOP_SO: "HOP_SO",
  MA_TAI_LIEU: "MA_TAI_LIEU",
  LOAI_BIEN_DONG: "LOAI_BIEN_DONG",
  DOCUMENT_EXTRACTION: "DOCUMENT_EXTRACTION",
  REQUEST_DATA_USAGE_STATUS: "REQUEST_DATA_USAGE_STATUS",
  THOI_HAN_SD: "THOI_HAN_SD",
  CHE_DO_SD: "CHE_DO_SD",
  MUC_DICH_SD_DAT: "MUC_DICH_SD_DAT",
  LINH_VUC: "LINH_VUC",
  STATUS_HO_SO: "STATUS_HO_SO",
  LOAI_DAT: "LOAI_DAT",
  NGON_NGU: "NGON_NGU",
  DO_MAT: "DO_MAT",
  DOSSIER_FORMUSE: "DOSSIER_FORMUSE",
  DOSSIER_PURPOSEUSE: "DOSSIER_PURPOSEUSE",
  DOSSIER_NETWORK: "DOSSIER_NETWORK",
  DOSSIER_FILE_TYPE: "DOSSIER_FILE_TYPE",
  FILE_IMPORT_SAMPLE_TEST_QUESTION: "FILE_IMPORT_SAMPLE_TEST_QUESTION",
  COURSE_STATUS: "COURSE_STATUS",
  COURSE_LEARN_FORM: "COURSE_LEARN_FORM",
  SEX_TYPE: "SEX_TYPE",
  COMMON_STATUS: "COMMON_STATUS",
  ACCOUNT_STATUS: "ACCOUNT_STATUS",
  POST_STATUS: "POST_STATUS",
  SUBMIT_SUPPORT_REQUEST_STATUS: "SUBMIT_SUPPORT_REQUEST_STATUS",
  COURSE_PRICE_TYPE: "COURSE_PRICE_TYPE",
  PRICE_BIDDING: "PRICE_BIDDING",
  QUALITY_SERVICE: "QUALITY_SERVICE",
  SATUS_POST_BIDDING: "SATUS_POST_BIDDING",
  ACADEMIC_LEVEL: "ACADEMIC_LEVEL",
  RANK: "RANK",
  CAREER_LEVEL: "CAREER_LEVEL",
  WAGE_TYPE: "WAGE_TYPE",
  WORKING_FORM: "WORKING_FORM",
  WELFARE: "WELFARE",
  DEGREE: "DEGREE",
  PRESENTATION_LANGUAGE: "PRESENTATION_LANGUAGE",
  FORM_WORKING: "FORM_WORKING",
  NUMBER_STAFF: "NUMBER_STAFF",
  NUMBER_EXP_YEAR: "NUMBER_EXP_YEAR",
  DOSSIER_PROCEDURE_TYPE: "DOSSIER_PROCEDURE_TYPE",
  SUBMISSION_STATUS: "SUBMISSION_STATUS",
  KHO_PHONG: "KHO_PHONG",
  GIA_TU: "GIA_TU",
  NGAN: "NGAN",
  KE: "KE",
  TANG: "TANG",
  TEMPLATE_FILE_IMPORT_POSITION: "TEMPLATE_FILE_IMPORT_POSITION",
  TEMPLATE_FILE_IMPORT_USER: "TEMPLATE_FILE_IMPORT_USER",
  TEMPLATE_FILE_IMPORT_DEPARTMENT: "TEMPLATE_FILE_IMPORT_DEPARTMENT",
  TEMPLATE_FILE_IMPORT_SYSTEM_CATE: "TEMPLATE_FILE_IMPORT_SYSTEM_CATE",
  TEMPLATE_IMPORT_DOSSIER: "TEMPLATE_IMPORT_DOSSIER",
  TEMPLATE_FILE_IMPORT_DOSSIER_FILE: "TEMPLATE_FILE_IMPORT_DOSSIER_FILE",
}
export const ACCOUNT_TYPE_ID = {
  KHACH_HANG_CA_NHAN: 2,
  DOANH_NGHIEP: 3,
  ADMIN: 9,
}

export const ACCOUNT_TYPE_ADMIN = [1, 2, 3, 4, 9]

export const COLOR_STATUS_HO_SO = ["", "#0D9D57", "#CE3135", "#CE3135"]

export const RATE_DESC = ["Rất tệ", "Tệ", "Bình thường", "Tốt", "Tuyệt vời"]

export const TYPE_LINK = {
  IMAGE_LINK: 1,
  VIDEO_LINK: 2,
  DOCUMENT_LINK: 3,
  COMPRESSION_LINK: 4,
}
